import { NavCloseIcon, OutlinedInfoIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { InvoiceLevelPaymentModes } from 'containers/invoices/InvoicesSlice';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';
import { getAmountWithCurrency } from 'utils/amountUtils';

interface PartialPaymentAvailablePopupProps {
  onClose: VoidFn;
  paymentModes: InvoiceLevelPaymentModes[];
  onCreateAnyway: VoidFn;
  onEditInvoice: VoidFn;
}

const PartialPaymentAvailablePopup: FC<PartialPaymentAvailablePopupProps> = ({
  onClose,
  paymentModes,
  onCreateAnyway,
  onEditInvoice
}) => {
  const getPaymentMethodLimits = () => {
    return paymentModes
      .filter(paymentMode => paymentMode.isSelected && paymentMode.teamLevelVisiblity && +paymentMode.maximumAmount > 0)
      .map(paymentMode => ({
        name: paymentMode.label,
        maximumAmount: paymentMode.maximumAmount
      }));
  };

  const paymentLimits = getPaymentMethodLimits();

  return (
    <CustomModal open={true} width="md:w-[400px]">
      <div className="relative">
        <div className="absolute right-2.5 top-2.5 cursor-pointer" onClick={onClose}>
          <NavCloseIcon />
        </div>
        <div className="flex flex-col items-center gap-3.5 px-8 pt-4">
          <div className="flex h-[70px] w-[70px] shrink-0 items-center justify-center rounded-full bg-[#EAF1FF]">
            <OutlinedInfoIcon className="h-8 w-8 text-secondary" />
          </div>

          <div className="text-center text-17px font-semibold text-primaryText">Only partial payments available</div>

          <div className="flex flex-col gap-3 text-left text-sbase text-primaryText">
            <div className="text-center">
              Due to payment limits, your customer may have some limitations on payment options:
            </div>

            {paymentLimits.length > 0 && (
              <div className="w-full space-y-3 overflow-hidden rounded border border-borderGray bg-white p-3">
                {paymentLimits.map((paymentLimit, index) => (
                  <div key={index} className="flex items-center">
                    <div className="flex-1 truncate text-sbase text-primaryText">{paymentLimit.name}</div>
                    <div className="flex-1 text-right text-sbase text-primaryText">
                      Up to {getAmountWithCurrency(paymentLimit.maximumAmount)}
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="text-center">Customers will see appropriate options based on their payment amount.</div>
          </div>
        </div>
        <div className="m-4 flex flex-col gap-3">
          <CustomButton id="create-anyway-btn" onClick={onCreateAnyway} className="h-12 w-full">
            Create anyway
          </CustomButton>
          <CustomButton
            id="edit-invoice-btn"
            onClick={onEditInvoice}
            type={ButtonType.SECONDARY}
            className="h-12 w-full">
            Edit invoice
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default PartialPaymentAvailablePopup;
